import { render, staticRenderFns } from "./DaiP_Items.vue?vue&type=template&id=f664bf54"
import script from "./DaiP_Items.vue?vue&type=script&lang=js"
export * from "./DaiP_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports